import services from '@/services.js'
import store from '@/store.js'
import { ORGANIZATION_PLAN_STATUS } from '../views/auth/constants'

const isRouteDenied = (to) => {
  const allowedRoutes = [
    // Settings
    'basic-info',
    'security',
    'api-key',
    'mainOrganization',
    'plan-overview',
    'plan-invoices',
    'TransactionsHistory',
    // Audience
    'audience',
    // Campaign
    'campaignList',
    'campaignResult',
    'campaignSummary',
    // Balance
    'manage-balance-plans',
    // Organization
    'OrganizationSelection',
  ]

  return !allowedRoutes.includes(to.name)
}

const handleOrganizationPlanSuspended = async (organizationId, to, fallbackRouteName) => {
  if (organizationId) {
    const response = await services.getOrganizationPlan(organizationId)
    const organizationPlanStatusRes = response.data.data.organizationPlanStatus

    store.dispatch('auth/setCachedOrganizationPlanStatus', organizationPlanStatusRes)
  }

  const shouldHandleSuspendedPlan =
    isRouteDenied(to) && store?.state?.auth?.organizationPlanStatus == ORGANIZATION_PLAN_STATUS.SUSPENDED && to.name !== fallbackRouteName

  return shouldHandleSuspendedPlan
}

export default handleOrganizationPlanSuspended
